<script setup lang="ts">
const error = useError();
const showErrorDetails = computed(() => process.env.NODE_ENV !== 'production');
const runtimeConfig = useRuntimeConfig();
const content_Url = runtimeConfig.public.karriere.content.url;
</script>

<template>
    <NuxtLayout name="content">
        <NuxtLoadingIndicator color="#142542" :height="2" class="shadow-lg" />
        <ErrorPage>
            <template #errorMessage>
                <div class="mx-auto">
                    <div class="text-center">
                        <BaseHeading variant="md-700">
                            Diese Seite konnte nicht gefunden werden.
                        </BaseHeading>
                        <BaseText class="mt-2">
                            Vielleicht finden Sie hier, wonach Sie suchen:
                        </BaseText>
                        <div class="mb-20 mt-6 px-dynamic">
                            <div class="flex justify-center">
                                <NuxtLink
                                    class="hover-box-shadow-animation m-2 flex size-full cursor-pointer items-center justify-center rounded-lg border border-gray-300 p-4 text-center sm:w-[250px]"
                                    to="/"
                                >
                                    <BaseHeading variant="base-700">Startseite</BaseHeading>
                                </NuxtLink>
                                <NuxtLink
                                    class="hover-box-shadow-animation m-2 flex size-full cursor-pointer items-center justify-center rounded-lg border border-gray-300 p-4 text-center sm:w-[250px]"
                                    href="/produkte/stelleninserate"
                                >
                                    <BaseHeading variant="base-700">Stelleninserate</BaseHeading>
                                </NuxtLink>
                            </div>
                            <div class="flex justify-center">
                                <NuxtLink
                                    class="hover-box-shadow-animation m-2 flex size-full cursor-pointer items-center justify-center rounded-lg border border-gray-300 p-4 text-center sm:w-[250px]"
                                    :href="`${content_Url}/hr/tipps`"
                                >
                                    <BaseHeading variant="base-700">HR Know-how</BaseHeading>
                                </NuxtLink>
                                <NuxtLink
                                    class="hover-box-shadow-animation m-2 flex size-full cursor-pointer items-center justify-center rounded-lg border border-gray-300 p-4 text-center sm:w-[250px]"
                                    :href="`${content_Url}/hr/faqs`"
                                >
                                    <BaseHeading variant="base-700">Häufige Fragen</BaseHeading>
                                </NuxtLink>
                            </div>
                        </div>
                    </div>
                    <details v-if="showErrorDetails" class="mt-3" open>
                        <summary>Details</summary>
                        <span
                            v-for="(value, key) in error"
                            :key="key"
                            class="block text-xs"
                        >{{ key }} : {{ value }}{{ '\n' }}</span
                        >
                    </details>
                </div>
            </template>
        </ErrorPage>
    </NuxtLayout>
</template>
